// extracted by mini-css-extract-plugin
export default {"root":"LayoutSideNavigation_root__3M5Ym","container":"LayoutSideNavigation_container__3R_jo","layoutWrapperMain":"LayoutSideNavigation_layoutWrapperMain__2nUxB"};